import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import EmailTemplateForm from "./emailTemplateComponents/EmailTemplateForm";

import {
  useGetEmailTemplateDetailQuery,
  useUpdateEmailTemplateMutation,
} from "store/services/emailTemplateApi";

import { useAppMeta } from "hooks";

const breadcrumbs = [
  { title: "Email Template", path: "/app/crm/email-template/list" },
  { title: "Edit Email Template" },
];

const EmailTemplateEditScreen = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  // RTK Query
  const { data: emailTemplateDetail, isLoading: loadingEmailTemplateDetail } =
    useGetEmailTemplateDetailQuery(id);

  const [updateEmailTemplate, { isLoading: updatingEmailTemplate }] =
    useUpdateEmailTemplateMutation();

  // methods
  const handleEmailTemplateUpdate = async (data) => {
    try {
      await updateEmailTemplate(data).unwrap();
      navigate(`/app/crm/email-template/${id}/detail`);

      toast.success("EmailTemplate successfully updated!");
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't update EmailTemplate!");
    }
  };

  useAppMeta("Edit EmailTemplate");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingEmailTemplateDetail}
    >
      <BreadcrumbLayout.Paper>
        <EmailTemplateForm
          emailTemplateDetail={emailTemplateDetail || updatingEmailTemplate}
          isBusy={loadingEmailTemplateDetail}
          onSubmit={handleEmailTemplateUpdate}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default EmailTemplateEditScreen;
